module.exports = __webpack_public_path__ + "static/img/yepeizhi.1d9531b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/yepeizhi.jpg
// module id = wUXk
// module chunks = 1